import React, { useEffect, useState } from "react";
import { PageBody, PageHeader } from "@/components/AppLayout";
import { FileDown } from "lucide-react";
import api, { exportExpensesCsvUrl } from "@/lib/api";

function money(n) { return `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`; }

export default function Reports() {
  const [kpis, setKpis] = useState(null);
  useEffect(() => { api.get("/api/dashboard/kpis").then((r) => setKpis(r.data)); }, []);
  return (
    <>
      <PageHeader title="Reports" subtitle="Donations, expenses, programs — one page, every metric, every export." />
      <PageBody>
        {kpis && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            <Stat label="Donations received" value={money(kpis.donations_received)} />
            <Stat label="Expenses paid" value={money(kpis.expenses_paid)} />
            <Stat label="Available funds" value={money(kpis.available_funds)} tone={kpis.available_funds < 0 ? "warning" : "default"} />
            <Stat label="Donors" value={kpis.donor_count} />
          </div>
        )}
        <section className="rounded-xl border border-border bg-card p-5">
          <h3 className="font-medium text-sm">Exports</h3>
          <p className="text-xs text-muted-foreground mt-1">Download CSV in any of these formats.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-4 text-sm">
            <a href={exportExpensesCsvUrl("trustdime")} className="flex items-center gap-2 rounded-md border border-border px-3 py-3 hover:bg-accent" data-testid="reports-export-td">
              <FileDown size={14} /> TrustDime full
            </a>
            <a href={exportExpensesCsvUrl("quickbooks")} className="flex items-center gap-2 rounded-md border border-border px-3 py-3 hover:bg-accent" data-testid="reports-export-qb">
              <FileDown size={14} /> QuickBooks Online
            </a>
            <a href={exportExpensesCsvUrl("aplos")} className="flex items-center gap-2 rounded-md border border-border px-3 py-3 hover:bg-accent" data-testid="reports-export-aplos">
              <FileDown size={14} /> Aplos
            </a>
          </div>
        </section>
      </PageBody>
    </>
  );
}

function Stat({ label, value, tone = "default" }) {
  const valueColor = tone === "warning" ? "text-amber-600" : "text-primary";
  return (
    <div className="rounded-xl border border-border bg-card p-5">
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium">{label}</div>
      <div className={`mt-2 text-3xl serif ${valueColor}`}>{value}</div>
    </div>
  );
}
